<div class="[ w-2xl ][ stack ]" data-cy="quicklink-dialog">
  @if (feedback$ | async; as feedback) {
    <campus-banner
      class="ui-banner--dialog"
      [id]="feedback.id"
      [message]="feedback.message"
      [icon]="feedback.icon"
      [actions]="feedback.userActions"
      (afterDismiss)="onBannerDismiss($event)"
    ></campus-banner>
  }

  <dcr-text-field
    type="search"
    [value]="searchTerm$ | async"
    placeholder="Zoeken..."
    (input)="onSearchInputChange($event)"
  ></dcr-text-field>

  @if (filteredCategories$ | async; as categories) {
    <div>
      @if (categories.length) {
        @if (categories[0].quickLinks.length) {
          @for (category of categories; track trackByTitle($index, category)) {
            @if (category.title) {
              <h6>{{ category.title }}</h6>
            }
            <dcr-list>
              @for (quickLink of category.quickLinks; track trackById($index, quickLink)) {
                <dcr-list-item
                  data-cy="quicklink-item"
                  [headline]="quickLink.name"
                  [attr.leading-icon]="'shared:' + quickLink.icon"
                  >
                  <div slot="trailing-actions">
                    @if (quickLink.defaultAction) {
                      <dcr-tonal-button
                        [label]="quickLink.defaultAction.label"
                        [attr.leading-icon]="'shared:' + quickLink.defaultAction.icon"
                        color="secondary"
                        (click)="onActionClick(quickLink.defaultAction, quickLink)"
                      ></dcr-tonal-button>
                    }
                    @if (quickLink.alternativeOpenActions.length || quickLink.manageActions.length) {
                      <div
                        class="[ relative ]"
                        >
                        <dcr-inline-icon-button
                          [id]="'more-actions-' + mode + '-' + quickLink.id"
                          icon="shared:more"
                        ></dcr-inline-icon-button>
                        <dcr-menu [anchor]="'more-actions-' + mode + '-' + quickLink.id" positioning="popover">
                          @for (action of quickLink.alternativeOpenActions; track trackByLabel($index, action)) {
                            <dcr-menu-item
                              [label]="action.label"
                              [attr.leading-icon]="'shared:' + action.icon"
                              (click)="onActionClick(action, quickLink)"
                            ></dcr-menu-item>
                          }
                          @if (quickLink.alternativeOpenActions.length && quickLink.manageActions.length) {
                            <dcr-divider
                            ></dcr-divider>
                          }
                          @for (action of quickLink.manageActions; track trackByLabel($index, action)) {
                            <dcr-menu-item
                              [label]="action.label"
                              [attr.leading-icon]="'shared:' + action.icon"
                              (click)="onActionClick(action, quickLink)"
                            ></dcr-menu-item>
                          }
                        </dcr-menu>
                      </div>
                    }
                  </div>
                </dcr-list-item>
              }
            </dcr-list>
          }
        } @else {
          <campus-empty-state
            svgImage="empty:searchresults"
            title="Geen resultaten"
            description="Je zoekterm leverde geen resultaten op. Probeer een andere zoekterm."
            ctaLabel="Filter verwijderen"
            ctaIcon="reset-filters"
            (clickCta)="clearFilter()"
          ></campus-empty-state>
        }
      } @else {
        <campus-empty-state
          [svgImage]="noContentMap[mode].svgImage"
          [title]="noContentMap[mode].title"
          [description]="noContentMap[mode].description"
        ></campus-empty-state>
      }
    </div>
  }
</div>

